module.exports = __webpack_public_path__ + "static/img/盛诺一家.ad50d48.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/cooperation/outer/盛诺一家.png
// module id = bL3f
// module chunks = 0 1 2 9